import React from 'react';

import { CheckCircleIcon, ClearIcon } from '@gogame/components';

const ActionStatus = ({ actionId }) => {
  switch (actionId) {
    case 2:
      return (
        <CheckCircleIcon
          fontSize={'small'} //#38b800
          color={'success'}
          sx={{ flexShrink: '0', fontSize: 16 }}
        />
      );
    case 3:
      return (
        <ClearIcon
          fontSize={'small'} //#dd2c00
          color={'error'}
          sx={{ flexShrink: '0', fontSize: 16 }}
        />
      );
    default:
      return null;
  }
};
export default ActionStatus;
